import { Tooltip, Box, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

/**
 * Small visual marker for fields/sections that are visible only to certain
 * roles (e.g., owner + admin). Backend already gates the data — this is
 * purely to inform the privileged viewer that what they're seeing isn't
 * visible to everyone with access.
 *
 * Pattern matches GitHub / Linear / Atlassian admin-only labels.
 *
 * Props:
 *   text   — short label (default "Admin & owner only")
 *   tip    — tooltip explaining who can see this
 *   variant — "chip" (label + icon, fuller) or "icon" (lock icon only)
 */
export default function RestrictedBadge({
  text = "Admin only",
  tip = "Visible only to Assertion admins. Platform internals like dataset names and run IDs are not shown to end-users (including project owners).",
  variant = "chip",
}) {
  if (variant === "icon") {
    return (
      <Tooltip title={tip}>
        <LockOutlinedIcon
          sx={{ fontSize: 14, color: "text.disabled", ml: 0.5, verticalAlign: "middle" }}
        />
      </Tooltip>
    );
  }
  return (
    <Tooltip title={tip}>
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.25,
          ml: 0.75,
          px: 0.75,
          py: 0.1,
          borderRadius: 0.75,
          border: "1px solid",
          borderColor: "divider",
          bgcolor: "action.hover",
          color: "text.secondary",
          fontSize: 10,
          fontWeight: 500,
          lineHeight: 1.5,
          cursor: "help",
          textTransform: "none",
          letterSpacing: 0,
        }}
      >
        <LockOutlinedIcon sx={{ fontSize: 11 }} />
        <Typography component="span" variant="caption" sx={{ fontSize: 10, fontWeight: 500 }}>
          {text}
        </Typography>
      </Box>
    </Tooltip>
  );
}
